export default __webpack_public_path__ + "navigation-overview-header-image-960-3bce78dd0f23e0e0f50e991d55b81562.webp";